import { module } from 'modujs';

export default class extends module {
    /**
     * Retrieves a list of elements matching the query.
     *
     * This method overrides the parent method to restore behaviour
     * from modujs <1.2.0. Otherwise, the parent method's new behaviour
     * would require a lengthy audit and rewrite of all modules.
     *
     * @param  {string}  query     - The module attribute query.
     * @param  {Element} [context] - The module context element.
     * @return {Element[]|Element}
     */
    $(query, context) {
        const els = super.$(query, context);

        if (els.length === 1) {
            return els[0];
        }

        return els;
    }
}
